import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useAxios } from 'zhooks'

type Option={
  label:string,
  value:number,
  childs:Option[],
  parent?:Option
}
export function useFolderTree() {
  const { folderId } = useParams()
  const { data: dict, refresh } = useAxios<Map<number, Option>, any>(async axios => {
    const _dict = new Map<number, Option>()
    const response = await axios.get('/backend-api/zhikuan/mn/sample/folder/simplify-folder-tree')
    const convert = (item, parent) => {
      const result = {
        label: item.folderName,
        value: item.id,
        parent,
        childs: []
      }
      if (item.childs.length > 0) {
        result.childs = item.childs.map((child) => convert(child, result))
      }
      _dict.set(result.value, result)
      return result
    }
    const root = { label: '样衣管理', value: 0, childs: [] } as Option
    root.childs = response.data.map((item) => convert(item, root))
    _dict.set(root.value, root)
    return _dict
  })

  const tree = useMemo(() => {
    const result = []
    let target = dict?.get(Number(folderId))
    while (target) {
      if (target.parent) {
        result.unshift(target)
      }
      target = target.parent
    }
    return result
  }, [folderId, dict])
  return { dict, tree, refresh }
}
